// extracted by mini-css-extract-plugin
module.exports = {"spin-wrapper":"Spinner_spin-wrapper__21sLt","spin":"Spinner_spin__1Orwz"};